module.exports = __webpack_public_path__ + "static/media/Paloma Ave, Burlingame, CA6.6843d8b5.jpg";